export default __webpack_public_path__ + "static/media/logo.86a9ed77.svg";